const Main = ({ children }) => {
  return (
    <main className='main d--middle d-flex d-flex--column'>
      <div className='main__inner w-0'>{children}</div>
    </main>
  )
}

export default Main
